import CircularProgress from '@mui/material/CircularProgress'
import { observer } from 'mobx-react-lite'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

type IconButtonWithProgressProps = {
   tooltip?: string
   loading?: boolean
} & React.ComponentProps<typeof IconButton>

export default observer(function IconButtonWithProgress(props: IconButtonWithProgressProps) {
   const { loading, children, tooltip, ...otherProps } = props
   const disabled = typeof otherProps.disabled === 'boolean' ? otherProps.disabled : loading
   return (
      <Tooltip title={tooltip ?? ''}>
         <IconButton
            {...otherProps}
            disabled={disabled}
         >
            {loading ? <CircularProgress sx={{ alignSelf: 'flex-end' }} size={20} /> : children}
         </IconButton>
      </Tooltip>
   )
})
